import { useEffect, useState } from 'react';
import { abandonner, listerEnAttente, surFileChangee, synchroniser, type EnAttente } from '../lib/offline';
import { dateHeureFr } from '../lib/format';
import { T } from '../i18n';

/**
 * Ce qui attend d'etre envoye. Tant que la file n'est pas vide, l'agent doit le
 * voir : une saisie qui dort sur un telephone et que personne ne reclame, c'est
 * la porte ouverte au retour du papier.
 */
export function FileHorsLigne() {
  const [n, setN] = useState(0);
  const [items, setItems] = useState<EnAttente[]>([]);
  const [ouvert, setOuvert] = useState(false);
  const [envoi, setEnvoi] = useState(false);

  useEffect(() => surFileChangee(setN), []);
  // La liste est chargee meme fermee : sans elle on ne sait pas s'il y a un refus
  // a signaler, et un refus ne doit pas attendre que quelqu'un clique sur « Voir ».
  useEffect(() => { void listerEnAttente().then(setItems); }, [n]);

  if (n === 0) return null;

  const refuses = items.filter((i) => i.rejete);
  const reconnexion = items.some((i) => i.reconnexion);
  const bloquant = refuses.length > 0 || reconnexion;

  return (
    <div style={{ marginBottom: 14 }}>
      <div className={`bandeau ${bloquant ? 'ko' : 'warn'}`} style={{ alignItems: 'center' }}>
        <div style={{ flex: 1 }}>
          {reconnexion ? (
            <>
              <b className="bandeau-t">{T.fileHorsLigne.reconnectezTitre(n)}</b>
              {T.fileHorsLigne.reconnectezTexte}
              <b>{T.fileHorsLigne.rienPerdu}</b>{T.fileHorsLigne.rienPerduSuite}
            </>
          ) : refuses.length > 0 ? (
            <>
              <b className="bandeau-t">{T.fileHorsLigne.refusesTitre(refuses.length)}</b>
              {T.fileHorsLigne.refusesTexte}
            </>
          ) : (
            <>
              <b className="bandeau-t">{T.fileHorsLigne.attenteTitre(n)}</b>
              {T.fileHorsLigne.attenteTexte}
            </>
          )}
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button className="btn btn-s" onClick={() => setOuvert(!ouvert)}>{ouvert ? T.fileHorsLigne.masquer : T.fileHorsLigne.voir}</button>
          <button className="btn btn-s btn-p" disabled={envoi || !navigator.onLine}
                  onClick={async () => { setEnvoi(true); await synchroniser(); setEnvoi(false); }}>
            {envoi ? T.fileHorsLigne.envoi : T.fileHorsLigne.envoyer}
          </button>
        </div>
      </div>
      {ouvert && (
        <div className="carte carte-p" style={{ marginTop: 8 }}>
          <table className="tbl compact">
            <thead><tr><th>{T.fileHorsLigne.colSaisie}</th><th>{T.fileHorsLigne.colCreee}</th><th className="droite">{T.fileHorsLigne.colEssais}</th><th /></tr></thead>
            <tbody>
              {items.map((i) => (
                <tr key={i.id}>
                  <td>
                    {i.libelle}
                    {i.rejete && <span className="badge refusee" style={{ marginLeft: 8 }}>{T.fileHorsLigne.refusee}</span>}
                    {i.erreur && <div className="mini" style={{ color: 'var(--danger)' }}>{i.erreur}</div>}
                  </td>
                  <td className="mini num">{dateHeureFr(new Date(i.creeLe))}</td>
                  <td className="droite num">{i.essais}</td>
                  <td className="droite">
                    {i.rejete && (
                      <button className="btn btn-s btn-f"
                              onClick={() => { if (confirm(T.fileHorsLigne.confirmerAbandon(i.libelle))) void abandonner(i.id); }}>
                        {T.fileHorsLigne.abandonner}

                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
